export default __webpack_public_path__ + "static/media/Poppins-SemiBold.ac8d04b6.ttf";